import {Yii} from "libraries/interfaces/Yii";

// Angular
import { Injectable } from '@angular/core';
import { IBreadcrumbItem } from 'libraries/service/breadcrumb/IBreadcrumbItem';

@Injectable()
export class SmsBreadcrumbService {
    public breadcrumbList (): IBreadcrumbItem[] {
        return [
            {
                name: Yii.t('wui-sasha-js', 'Modèles'),
                isActive: true,
                isClickable: false,
                action: null,
                routerLink: ['/sasha/processing-sms']
            }, {
                name: Yii.t('wui-sasha-js', 'Saisie'),
                isActive: false,
                isClickable: false,
                action: null,
                routerLink: ['/sasha/processing-sms/form']
            }, {
                name: Yii.t('wui-sasha-js', 'Prévisualisation'),
                isActive: false,
                isClickable: false,
                action: null,
                routerLink: ['/sasha/processing-sms/validation']
            }
        ];
    }

    public breadcrumbForm (): IBreadcrumbItem[] {
        return [
            {
                name: Yii.t('wui-sasha-js', 'Modèles'),
                isActive: false,
                isClickable: true,
                action: null,
                routerLink: ['/sasha/processing-sms']
            }, {
                name: Yii.t('wui-sasha-js', 'Saisie'),
                isActive: true,
                isClickable: false,
                action: null,
                routerLink: ['/sasha/processing-sms/form']
            }, {
                name: Yii.t('wui-sasha-js', 'Validation'),
                isActive: false,
                isClickable: false,
                action: null,
                routerLink: ['/sasha/processing-sms/validation']
            }
        ];
    }

    public breadcrumbValidation (): IBreadcrumbItem[] {
        return [
            {
                name: Yii.t('wui-sasha-js', 'Modèles'),
                isActive: false,
                isClickable: true,
                action: null,
                routerLink: ['/sasha/processing-sms']
            }, {
                name: Yii.t('wui-sasha-js', 'Saisie'),
                isActive: false,
                isClickable: true,
                action: null,
                routerLink: ['/sasha/processing-sms/form']
            }, {
                name: Yii.t('wui-sasha-js', 'Validation'),
                isActive: true,
                isClickable: false,
                action: null,
                routerLink: ['/sasha/processing-sms/validation']
            }
        ];
    }

    public breadcrumbValidationMessage (): IBreadcrumbItem[] {
        return [
            {
                name: Yii.t('wui-sasha-js', 'Modèles'),
                isActive: false,
                isClickable: true,
                action: null,
                routerLink: ['/sasha/processing-sms']
            }, {
                name: Yii.t('wui-sasha-js', 'Saisie'),
                isActive: false,
                isClickable: true,
                action: null,
                routerLink: ['/sasha/processing-sms/form']
            }, {
                name: Yii.t('wui-sasha-js', 'Validation'),
                isActive: false,
                isClickable: true,
                action: null,
                routerLink: ['/sasha/processing-sms/validation']
            }
        ];
    }
}